<template>
    <dashboard-layout title="브릿지">
        <template #contents>
            <expo-program-list-filter class="mb-20 mb-lg-40" v-bind="{ loading }" />

            <template v-if="items.length">
                <div class="v-cards">
                    <template v-for="item in items">
                        <expo-program-item :value="item" :key="item._id">
                            <template #actions>
                                <v-row class="ma-n4">
                                    <v-col cols="auto" class="pa-4">
                                        <expo-employee-form
                                            v-model="item.employee"
                                            v-bind="{
                                                program: item,
                                            }"
                                            @input="updateItem_employee"
                                        >
                                            <template #activator="{ attrs, on }">
                                                <v-btn small color="primary" class="min-w-80px min-w-lg-120px" v-bind="attrs" v-on="on">
                                                    <span> 지원정보 수정 </span>
                                                </v-btn>
                                            </template>
                                        </expo-employee-form>
                                    </v-col>
                                    <v-col cols="auto" class="pa-4">
                                        <expo-employee-remove v-bind="{ value: item }" v-on="{ search }">
                                            <template #activator="{ attrs, on }">
                                                <v-btn small outlined color="grey-d" class="min-w-80px min-w-lg-120px" v-bind="attrs" v-on="on">
                                                    <span class="grey-6--text"> 신청취소 </span>
                                                </v-btn>
                                            </template>
                                        </expo-employee-remove>
                                    </v-col>
                                </v-row>
                            </template>
                        </expo-program-item>
                    </template>
                </div>

                <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" @input="(page) => $router.push({ query: { ...$route.query, page } })" />
            </template>
            <template v-else>
                <v-layout column justify-center align-center class="w-100 grey-f7 rounded-lg pa-20" :style="innerWidth < 1024 ? { height: 'calc(100vh - 367px)' } : { height: 'calc(100vh - 472px)' }">
                    <p class="page-text--lg line-height-15 text-center mb-12 mb-lg-32">
                        안녕하세요, 회원님. <br />
                        참여중인 프로그램이 없습니다.
                    </p>
                    <v-btn text height="auto" color="transparent" class="v-btn--column" href="/programs">
                        <i class="icon icon-plus-lg" />
                        <span class="mt-6 mt-lg-14 grey-9--text">프로그램 참여하기</span>
                    </v-btn>
                </v-layout>
            </template>
        </template>
    </dashboard-layout>
</template>

<script>
import api from "@/api";
import { mapState } from "vuex";
import { initExpoEmployee, initExpoProgram } from "@/assets/variables/inits";

import DashboardLayout from "@/components/dashboard/dashboard-layout.vue";
import ExpoProgramItem from "@/components/dashboard/common/expo/program/expo-program-item.vue";
import ExpoProgramListFilter from "@/components/dashboard/common/expo/program/expo-program-list-filter.vue";

import ExpoEmployeeForm from "@/components/client/expo/employee/expo-employee-form.vue";
import ExpoEmployeeRemove from "@/components/client/expo/employee/expo-employee-remove.vue";

export default {
    components: {
        DashboardLayout,
        ExpoProgramItem,
        ExpoProgramListFilter,

        ExpoEmployeeForm,
        ExpoEmployeeRemove,
    },
    data: () => ({
        loading: false,

        programs: [],
        employees: [],

        limit: 10,
        summary: { totalCount: 0 },

        loading: false,
    }),
    computed: {
        ...mapState("ui", { innerWidth: (store) => store.window.innerWidth }),
        items() {
            return this.programs.map((item, index) =>
                initExpoProgram({
                    ...item,
                    index: this.summary.totalCount - (this.page - 1) * this.limit - index,
                    employee: this.employees.find(({ _program }) => _program == item._id),
                })
            );
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;

            query.mode = query.mode ?? "on-going";

            return { ...query };
        },
    },
    methods: {
        init() {
            this.search();
        },
        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { skip, limit, params } = this;
                let { summary, programs } = await api.v1.person.expo.programs.gets({
                    headers: { skip, limit },
                    params,
                });

                this.programs = programs;
                this.summary = summary;

                let { employees } = await api.v1.person.expo.employees.gets();
                this.employees = employees.map(initExpoEmployee);
            } finally {
                if (this.loading) this.loading = false;
            }
        },
        updateItem(item) {
            const index = this.programs.findIndex(({ _id }) => _id == item._id);
            if (0 <= index) this.programs.splice(index, 1, item);
            else {
                this.programs = [item, ...this.programs];
                this.summary.totalCount += 1;
            }
            this.search();
        },
        updateItem_employee(item) {
            const index = this.employees.findIndex(({ _id }) => _id == item._id);
            if (0 <= index) this.employees.splice(index, 1, item);
            else {
                this.employees = [item, ...this.employees];
            }
            this.search();
        },
    },
    watch: {
        params() {
            this.search();
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style>
</style>